import React from 'react';
import Icon from '../../../components/AppIcon';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';

const IntimacyTrendsChart = ({ data, timeRange }) => {
  const getTimeRangeLabel = (range) => {
    switch (range) {
      case '7d': return 'Last 7 Days';
      case '30d': return 'Last 30 Days';
      case '90d': return 'Last 90 Days';
      case '1y': return 'Last Year';
      default: return 'Last 30 Days';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6 shadow-therapeutic-sm">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground">
            Intimacy Trends
          </h3>
          <p className="text-sm text-muted-foreground mt-1">
            {getTimeRangeLabel(timeRange)} - Frequency & Satisfaction
          </p>
        </div>
        <div className="flex items-center gap-2">
          <Icon name="Activity" size={20} color="var(--color-primary)" />
        </div>
      </div>

      <div className="w-full h-64 md:h-80" aria-label="Intimacy trends line chart">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
            <XAxis 
              dataKey="date" 
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '12px' }}
            />
            <YAxis 
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '12px' }}
            />
            <Tooltip 
              contentStyle={{
                backgroundColor: 'var(--color-card)',
                border: '1px solid var(--color-border)',
                borderRadius: '6px',
                fontSize: '12px'
              }}
            />
            <Legend 
              wrapperStyle={{ fontSize: '12px' }}
            />
            <Line 
              type="monotone" 
              dataKey="frequency" 
              stroke="var(--color-primary)" 
              strokeWidth={2}
              name="Frequency"
              dot={{ fill: 'var(--color-primary)', r: 4 }}
            />
            <Line 
              type="monotone" 
              dataKey="satisfaction" 
              stroke="var(--color-success)" 
              strokeWidth={2}
              name="Satisfaction"
              dot={{ fill: 'var(--color-success)', r: 4 }}
            />
            <Line 
              type="monotone" 
              dataKey="mood" 
              stroke="var(--color-accent)" 
              strokeWidth={2}
              name="Mood Correlation"
              dot={{ fill: 'var(--color-accent)', r: 4 }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>

      <div className="mt-4 grid grid-cols-3 gap-4">
        <div className="text-center">
          <p className="text-xs text-muted-foreground mb-1">Avg Frequency</p>
          <p className="text-lg font-heading font-semibold text-primary">
            {(data?.reduce((sum, item) => sum + item?.frequency, 0) / data?.length)?.toFixed(1)}
          </p>
        </div>
        <div className="text-center">
          <p className="text-xs text-muted-foreground mb-1">Avg Satisfaction</p>
          <p className="text-lg font-heading font-semibold text-success">
            {(data?.reduce((sum, item) => sum + item?.satisfaction, 0) / data?.length)?.toFixed(1)}
          </p>
        </div>
        <div className="text-center">
          <p className="text-xs text-muted-foreground mb-1">Mood Score</p>
          <p className="text-lg font-heading font-semibold text-accent">
            {(data?.reduce((sum, item) => sum + item?.mood, 0) / data?.length)?.toFixed(1)}
          </p>
        </div>
      </div>
    </div>
  );
};

export default IntimacyTrendsChart;